module.exports = __webpack_public_path__ + "static/img/share_stap2.e554acf.png";


//////////////////
// WEBPACK FOOTER
// ./static/share_stap2.png
// module id = hulD
// module chunks = 0